import { httpApi } from '@api/http.api.ts';

export interface UpdateUserConsentRequest {
    accepted: number[];
}

export const updateUserConsent = (UpdateUserConsentPayload: UpdateUserConsentRequest): Promise<any> =>
    httpApi.post<any>(`users/consents`, { ...UpdateUserConsentPayload }).then(({ data }) => data);
